import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const MyContentContext = createContext();

const MyContentProvider = ({ children }) => {
  const [questionSetName, setQuestionSetName] = useState('');
  const [questionSetId, setQuestionSetId] = useState(null);
  const [questionId, setQuestionId] = useState(0);
  const [question, setQuestion] = useState('blank question');
  const [hint, setHint] = useState('');
  const [reason, setReason] = useState('');
  const [questionType, setQuestionType] = useState(1);
  const [numChoices, setNumChoices] = useState(4);
  const [correctAnswer, setCorrectAnswer] = useState(1);
  const [fillInAnswer, setFillInAnswer] = useState('blank answer');
  const [fillInAnswerBoxWidth, setFillInAnswerBoxWidth] = useState(10);
  const [fillInAnswerBoxFontSize, setFillInAnswerBoxFontSize] = useState(10);
  const [selectedAttributeNodes, setSelectedAttributeNodes] = useState([]);
  const [selectedTagNodes, setSelectedTagNodes] = useState([]);
  const [selectedStandardNodes, setSelectedStandardNodes] = useState([]);
  const [selectedTopicNodes, setSelectedTopicNodes] = useState([]);
  const [activeTab, setActiveTab] = useState('questionsets');
  const [selectedSets, setSelectedSets] = useState([]);
  const [selectedDocumentIds, setSelectedDocumentIds] = useState([]);
  const [questionDocuments, setQuestionDocuments] = useState([]);
  const [sampleAnswer, setSampleAnswer] = useState('');
  const [answerSize, setAnswerSize] = useState(2);
  const [maxPoints, setMaxPoints] = useState(1);
  const [editAnswer, setEditAnswer] = useState('');
  const [options, setOptions] = useState(0);
  const [crAnswerToolId, setCrAnswerToolId] = useState(1);
  const [dateTimeBasedUniqueKey, setDateTimeBasedUniqueKey] = useState(new Date().getTime().toString());

  const resetContext = () => {
    setQuestionSetName('');
    setQuestionSetId(null);
    setQuestionId(0);
    setQuestion('blank question');
    setHint('');
    setReason('');
    setQuestionType(1);
    setNumChoices(4);
    setCorrectAnswer(1);
    setFillInAnswer('blank answer');
    setFillInAnswerBoxWidth(10);
    setFillInAnswerBoxFontSize(10);
    setSelectedAttributeNodes([]);
    setSelectedTagNodes([]);
    setSelectedStandardNodes([]);
    setSelectedTopicNodes([]);
    setSelectedDocumentIds([]);
    setQuestionDocuments([]);
    setSampleAnswer('');
    setAnswerSize(2);
    setMaxPoints(1);
    setEditAnswer('');
    setOptions(0);
    setCrAnswerToolId(1);
  };

  return (
    <MyContentContext.Provider value={{
      questionSetName, setQuestionSetName, questionSetId, setQuestionSetId,
      question, setQuestion, hint, setHint, reason, setReason, questionType, setQuestionType, numChoices, setNumChoices,
      correctAnswer, setCorrectAnswer, fillInAnswer, setFillInAnswer, fillInAnswerBoxFontSize, setFillInAnswerBoxFontSize, fillInAnswerBoxWidth,
      setFillInAnswerBoxWidth, selectedAttributeNodes, setSelectedAttributeNodes, selectedTagNodes, setSelectedTagNodes, selectedStandardNodes,
      setSelectedStandardNodes, selectedTopicNodes, setSelectedTopicNodes, activeTab, setActiveTab, selectedSets, setSelectedSets,
      questionId, setQuestionId, resetContext, selectedDocumentIds, setSelectedDocumentIds, questionDocuments, setQuestionDocuments,
      sampleAnswer, setSampleAnswer, answerSize, setAnswerSize, maxPoints, setMaxPoints, editAnswer, setEditAnswer, options, setOptions, dateTimeBasedUniqueKey, setDateTimeBasedUniqueKey,
      crAnswerToolId, setCrAnswerToolId
    }}>
      {children}
    </MyContentContext.Provider>
  );
};

MyContentProvider.propTypes = {
  children: PropTypes.any
};

export const useMyContentContext = () => useContext(MyContentContext);
export { MyContentProvider };